import http from '@/api/http';
export var AUTH_URL = 'api/v5/auth';
export function getAuthGrant(data, options) {
  return http.get("".concat(AUTH_URL, "/grant"), data, options).then(function (response) {
    return response.data;
  });
}